module.exports = __webpack_public_path__ + "static/media/ViewFullScreen.7c95c723.svg";